import { Image } from 'react-native';
import { Flex, useScreenSize } from '@banhala/ui-kit';

export const FavoriteMarketEmpty = () => {
  const { width } = useScreenSize();
  return (
    <Flex
      flex={1}
      alignItems={'center'}
      backgroundColor={'content_always_white'}
      padding={{ top: 24 }}
    >
      <Image
        source={require('./images/image_favorite_market_empty.jpg')}
        style={{ width, height: width * (366 / 360) }}
        resizeMode={'contain'}
      />
    </Flex>
  );
};
